import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StaffManagement from './StaffManagement';
import AttendanceManagement from './AttendanceManagement';
import RoleManagement from './RoleManagement';
import StaffPerformance from './StaffPerformance';

const StaffDashboard = ({ isFullscreen = false }) => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('staff');

    const tabs = [
        { id: 'staff', label: 'Staff', icon: '👥' },
        { id: 'roles', label: 'Roles & Permissions', icon: '🔐' },
        { id: 'attendance', label: 'Attendance', icon: '📅' },
        { id: 'performance', label: 'Staff Performance', icon: '📊' }
    ];

    const renderContent = () => {
        switch (activeTab) {
            case 'staff':
                return <StaffManagement />;
            case 'roles':
                return <RoleManagement />;
            case 'attendance':
                return <AttendanceManagement />;
            case 'performance':
                return <StaffPerformance />;
            default:
                return <StaffManagement />;
        }
    };

    return (
        <div className="min-h-screen bg-stone-100 overflow-x-hidden">
            <div className="sticky top-0 z-10 bg-white border-b border-stone-200 shadow-sm">
                <div className="px-3 py-2 sm:px-5 sm:py-2">
                    <div className="flex flex-wrap items-center justify-between gap-2">
                        <div className="flex flex-wrap items-center gap-2">
                            {tabs.map((tab) => (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`px-3 py-2 rounded-xl text-xs sm:text-sm font-semibold transition-all ${
                                        activeTab === tab.id
                                            ? 'bg-orange-500 text-white shadow-md'
                                            : 'bg-white text-stone-600 border border-stone-200 hover:bg-stone-50'
                                    }`}
                                >
                                    <span className="mr-1.5">{tab.icon}</span>
                                    {tab.label}
                                </button>
                            ))}
                                                    {!isFullscreen && (
                            <button
                                type="button"
                                onClick={() => navigate('/restaurant/staff-fullscreen')}
                                className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-stone-200 bg-white text-stone-600 hover:bg-stone-50 hover:text-stone-800 transition-colors flex-shrink-0"
                                title="Fullscreen"
                                aria-label="Fullscreen"
                            >
                                <span className="text-sm">⤢</span>
                            </button>
                        )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-3 sm:p-5 w-full min-w-0">
                {renderContent()}
            </div>
        </div>
    );
};

export default StaffDashboard;

